import { render, staticRenderFns } from "./IconHatchback.vue?vue&type=template&id=753dd6c5"
import script from "./IconHatchback.vue?vue&type=script&lang=js"
export * from "./IconHatchback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports